<template>
  <div class="PageForm">
    <el-form
      ref="form"
      :rules="siteRules"
      :model="form"
      label-width="120px"
    >
      <el-form-item
        prop="name"
        label="站点名称"
      >
        <el-input
          v-model.trim="form.name"
          :maxlength="20"
          :disabled="!authority || form.from === 'front'"
          placeholder="请输入站点名称"
        />
      </el-form-item>
      <el-form-item label="站点logo">
        <!-- <upload-img
          :userid="cpUserId"
          :placeholder="'static/layout/icon_default_school_pray.png'"
          :src="form.logo"
          :canedit="authority && form.from !== 'front'"
          @upload-success="uploadSuccess"
        /> -->
        <div :class="['setting-content']">
          <div
            class="img-container logo-container"
            @click.stop="uploadPicture('logo')"
          >
            <img
              :src="form.logo"
              :onerror="defaultLogoImage"
              alt=""
              class="image-item"
            >
            <div
              class="pos-handler application-handler"
            >
              <div
                class="icon-container"
                :class="{'full_width':!authority || form.from === 'front'}"
              >
                <i
                  class="el-icon-view"
                  @click.stop="previewEvent(form.logo)"
                />
              </div>
              <div
                v-if="authority && form.from !== 'front'"
                class="icon-container"
              >
                <i
                  class="el-icon-delete"
                  @click.stop="handleDeleteImage('logo')"
                />
              </div>
            </div>
          </div>
          <div class="common-tips">
            <div>建议最小尺寸200*50px，文件大小不超过1M</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        prop="orgType"
        label="所属单位"
      >
        <el-select
          v-model="orgType"
          style="margin-bottom:12px;"
          placeholder="请选择"
          :disabled="!authority || form.from === 'front'"
          @change="changeOrgType"
        >
          <el-option
            v-for="item in orgTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select
          v-if="form.orgId !== '1'"
          v-model="form.orgId"
          filterable
          remote
          reserve-keyword
          placeholder="请输入单位名称"
          :remote-method="remoteMethod"
          @focus="foucsHandler"
          @change="changeOrgId"
        >
          <el-option
            v-for="item in companies"
            :key="item.orgId"
            :label="item.orgType == 2 && item.alias ? item.alias + '-' + item.name : item.orgType == 3 && item.alias ? item.alias : item.name"
            :value="item.orgId"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        prop="description"
        label="网站描述"
      >
        <el-input
          v-model="form.description"
          resize="none"
          type="textarea"
          :rows="4"
          maxlength="50"
          placeholder="请输入网站描述"
          show-word-limit
          :disabled="!authority || form.from === 'front'"
        />
      </el-form-item>
      <el-form-item
        :prop="form.webTemplate ? 'webTemplate' : 'h5Template'"
        label="站点模板"
      >
        <el-select
          v-model="form.h5Template"
          placeholder="请选择网站H5模板"
          :disabled="!authority || form.from === 'front'"
          clearable
          @change="changeWebTemplate"
        >
          <el-option
            v-for="item in h5Templates"
            :key="item.templateNo"
            :label="item.name"
            :value="item.templateNo"
          />
        </el-select>
        <p style="margin-top:10px" />
        <el-select
          v-model="form.webTemplate"
          style="margin-bottom:12px;"
          placeholder="请选择网站web模板"
          :disabled="!authority || form.from === 'front'"
          clearable
          @change="changeH5Template"
        >
          <el-option
            v-for="item in webTemplates"
            :key="item.templateNo"
            :label="item.name"
            :value="item.templateNo"
          />
        </el-select><br>

        <span style="color:#F3864B;">web或H5模板必填一项</span>
      </el-form-item>
      <el-form-item
        prop="address"
        label="网站访问地址"
      >
        <el-input
          v-model.trim="cp_address"
          style="margin-bottom:12px;"
          disabled
        />
        <el-button
          v-if="mode === 'add'"
          size="medium"
          type="primary"
          @click="autoCreate"
        >
          自动生成
        </el-button>
        <el-button
          v-else
          v-clipboard:copy="cp_address"
          v-clipboard:success="onSuccess"
          v-clipboard:error="onError"
          size="medium"
          type="primary"
        >
          复制地址
        </el-button>
      </el-form-item>
      <el-form-item
        prop="level"
        label="栏目层级"
      >
        <el-select
          v-model="form.level"
          placeholder="请选择"
          :disabled="!authority || form.from === 'front'"
        >
          <el-option
            v-for="item in levels"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="是否登录后访问"
      >
        <el-radio-group
          v-model="form.isLogin"
          :disabled="form.webTemplate === 'WEB-003'"
          @change="$forceUpdate()"
        >
          <el-radio
            :label="1"
          >
            是
          </el-radio>
          <el-radio
            :label="0"
          >
            否
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="form.webTemplate === 'WEB-003'"
        prop="copyright"
        label="版权信息"
      >
        <el-input
          v-model.trim="form.copyright"
          :maxlength="120"
          placeholder="请输入版权信息"
          :disabled="!authority || form.from === 'front'"
        />
      </el-form-item>
      <el-form-item
        v-if="form.webTemplate === 'WEB-003'"
        prop="icpFilingCode"
        label="ICP备案号"
      >
        <el-input
          v-model.trim="form.icpFilingCode"
          :maxlength="120"
          placeholder="请输入ICP备案号"
          :disabled="!authority || form.from === 'front'"
        />
      </el-form-item>
      <el-form-item
        v-if="form.webTemplate === 'WEB-003'"
        prop="policeFilingCode"
        label="公安备案号"
      >
        <el-input
          v-model.trim="form.policeFilingCode"
          :maxlength="120"
          placeholder="公安备案号"
          :disabled="!authority || form.from === 'front'"
        />
      </el-form-item>
    </el-form>
    <!--图片上传-->
    <Uploader
      ref="uploader"
      :limit="1"
      @uploadSuccess="handleUploadSuccess"
    />
  </div>
</template>

<script>
import api from '../proxy';
import templateApi from '../../templateMana/proxy';
// import UploadImg from '../../../common/tools/UploadImg';
import Uploader from '@/components/common/Uploader';
// import emojiRegex from 'emoji-regex';
export default {
    name: 'PageForm',
    components: { Uploader },
    props: {
        form: {
            type: Object,
            default () {
                return {};
            },
        },
        mode: { // add新增站点 edit编辑
            type: String,
            default: '',
        },
    },
    data () {
        var checkName = (rule, value, callback) => {
            if (!value) return callback(new Error('请输入站点名称'));
            let re = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]");
            if (re.test(value)) {
                callback(new Error('请不要输入特殊字符'));
            } else {
                callback();
            }
        };
        return {
            webTemplates: [], // web模板列表
            h5Templates: [], // h5模板列表
            companies: [],
            levels: ['1', '2', '3', '4', '5', '6', '7', '8', '9'], // 栏目层级1到9
            orgType: '0',
            orgTypes: [
                {
                    value: '0',
                    label: '优学派',
                },
                {
                    value: '2',
                    label: '其他单位',
                },
            ],
            siteRules: {
                name: {
                    required: true,
                    validator: checkName,
                    trigger: 'blur',
                },
                orgType: {
                    required: true,
                    message: '请选择单位',
                },
                description: {
                    required: true,
                    message: '请输入50个字以内的网站描述',
                    trigger: 'blur',
                },
                webTemplate: {
                    required: true,
                    message: ' ',
                    trigger: 'change',
                },
                h5Template: {
                    required: true,
                    message: ' ',
                    trigger: 'change',
                },
                address: {
                    required: true,
                    message: '网站访问地址不能为空',
                },
                level: {
                    required: true,
                    message: '栏目层级不能为空',
                },
                copyright: {
                    required: true,
                    message: '版权信息不能为空',
                },
                icpFilingCode: {
                    required: true,
                    message: 'ICP备案号不能为空',
                },
            },
            defaultLogoImage: 'this.src="' + require('../../../../assets/image/logo-default.png') + '"', // LOGO默认图
        };
    },
    computed: {
        currentOrg () {
            return this.$store.getters['global/currentOrg'];
        },
        cpUserId () {
            return this.$store.state.global.loginInfo.userId;
        },
        identity () {
            return this.$store.getters['system/getSiteList'][0].identity;
        },
        userIdentity () {
            return this.$store.getters['global/userIdentity'];
        },
        authority () {
            return this.userIdentity === 1 || this.userIdentity === 2;
        },
        cp_address () {
            if (this.form.webTemplate === 'WEB-004') {
                if (!this.form.address) return '';
                const host = window.yxpapiConfig.env === 'production' ? 'www.youxuezixishi.com' : 'www-test.youxuezixishi.com';
                const url = new URL(this.form.address);
                return `https://${host}${url.pathname}${url.hash}`;
            }
            return this.form.address;
        },
    },
    created: function () {
        // if (this.form.h5Template && !this.form.webTemplate) {
        //     this.siteRules.h5Template.required = true;
        //     this.siteRules.webTemplate.required = false;
        // } else {
        //     this.siteRules.webTemplate.required = true;
        //     this.siteRules.h5Template.required = false;
        // }

        if (this.form.webTemplate === 'WEB-003') {
            this.siteRules.copyright.required = true;
            this.siteRules.icpFilingCode.required = true;
        } else {
            this.siteRules.copyright.required = false;
            this.siteRules.icpFilingCode.required = false;
        }
        if (this.form.orgId === '1') {
            this.orgType = '0';
        } else {
            this.orgType = '2';
        }
        if (this.form.orgId) this.companies = [{ name: this.form.orgName, orgId: this.form.orgId }];
    },
    mounted: function () {
        let params = {
            type: '',
            status: 1,
            pageNo: 1,
            pageSize: 999,
        };
        templateApi.getTplList(params).then((res) => {
            if (res.errcode === 0) {
                this.webTemplates = res.data.records.filter((itm) => {
                    return itm.type === 0;
                });
                this.h5Templates = res.data.records.filter((itm) => {
                    return itm.type === 1;
                });
            } else {
                this.$message.error(res.errmsg);
            }
        });
    },
    methods: {
        changeWebTemplate () {
            // this.siteRules.webTemplate.required = true;
            // this.siteRules.h5Template.required = false;
        },
        changeH5Template () {
            // this.siteRules.h5Template.required = true;
            // this.siteRules.webTemplate.required = false;
            if (this.form.webTemplate === 'WEB-003') {
                this.siteRules.copyright.required = true;
                this.siteRules.icpFilingCode.required = true;
                this.form.isLogin = 0;
            } else {
                this.siteRules.copyright.required = false;
                this.siteRules.icpFilingCode.required = false;
            }
        },
        onSuccess (e) {
            this.$message.success('复制成功');
        },
        onError (e) {
            this.$message.error('复制失败');
        },
        uploadSuccess (p) { // logo上传成功回调
            this.form.logo = p.fileUrl;
        },

        // 上传图片
        uploadPicture (type) {
            if (!this.authority || this.form.from === 'front') {
                return;
            }
            if (!this.$refs.uploader.isUploading) {
                this.$refs.uploader.init('logo');
            } else {
                this.$message({
                    type: 'error',
                    message: '文件上传中，请稍后再试',
                });
            }
        },
        // 图片上传成功
        handleUploadSuccess (list) {
            const curData = list && list[0];
            const curFiles = curData && curData.result;
            // let params = {};
            if (curData.status === 'succ') {
                console.log(1111, curFiles.fileUrl);
                console.log(2222, curFiles.filePath);
                this.form.logo = curFiles.fileUrl;
            }
            this.$refs.uploader.isUploading = false;
        },
        autoCreate () { // 自动生成网址和id
            let params = {
                address: `${window.location.origin}/yxp-page-manage/#/mobile`,
            };
            api.generateAddress(params).then((res) => {
                if (res.errcode === 0) {
                    this.form.address = res.data.websiteAddress;
                    this.form.addressId = res.data.id;
                    // 20220406 设置版权信息
                    if (this.form.address.includes('youxueketang.com') || this.form.address.includes('/yxp-page-manage/')) {
                        this.form.copyright = 'Copyright © 2018-2023 anoah.com All rights reserved';
                        this.form.icpFilingCode = '蜀ICP备13026056号-1';
                    }
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        copyAddress () { // 复制地址
            console.log(1);
        },
        changeOrgType () { // 修改所属单位类型
            if (this.orgType === '0') {
                this.form.orgId = '1';
                this.form.orgType = '0';
            } else {
                this.form.orgId = '';
                this.form.orgType = '';
            }
            console.log(this.form.orgId);
        },
        changeOrgId () {
            let org = this.companies.find(item => item.orgId === this.form.orgId);
            this.form.orgType = org.orgType;
        },
        foucsHandler () {
            if (!this.form.orgId) this.companies = [];
        },
        remoteMethod (query) { // 输入名称获取user
            let me = this;
            if (query !== '') {
                setTimeout(() => {
                    let params = {
                        content: query,
                        pageNo: 1,
                        pageSize: 999,
                    };
                    api.listOrgByKeywords(params).then((res) => {
                        if (res.errcode === 0) {
                            me.companies = res.data.list;
                        } else {
                            me.$message.error(res.errmsg);
                        }
                    });
                }, 200);
            } else {
                me.companies = [];
            }
        },

        // 图片预览
        previewEvent (src) {
            if (src) {
                window.open(src);
            } else {
                this.$message({
                    type: 'error',
                    message: '暂无图片',
                });
            }
        },

        // 处理图片删除
        handleDeleteImage (val) {
            this.form.logo = '';
        },
    },
};
// <style lang="scss">
// .el-select-dropdown__item {
//     width: 360px;
// }
// </style>
</script>

<style scoped lang="scss">
@import "../../../../sass/theme.scss";
</style>
<style scoped lang="scss">
.PageForm {
  .setting-content {
    flex: 1;

    .img-container {
        background-color: #F0F0F0;
        margin-bottom: 16px;
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;

        &:hover {
        .pos-handler {
            bottom: 0 !important;
        }
        }

        &.logo-container {
        width: 200px;
        height: 50px;
        }

        &.wallpaper-container {
        width: 200px;
        height: 100px;
        }

        .image-item {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        }

        .pos-handler {
        position: absolute;
        left: 0;
        width: 100%;
        background: rgba(150, 150, 150, .6);
        color: #fff;
        -webkit-transition: bottom .2s linear;
        -moz-transition: bottom .2s linear;
        -ms-transition: bottom .2s linear;
        -o-transition: bottom .2s linear;
        transition: bottom .2s linear;
        display: flex;

        [class^=el-icon] {
            padding: 5px;
            font-size: 1.2rem;
            cursor: pointer;
            &:hover {
            color: #2ED095;
            }
        }

        .icon-container {
            width: 50%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            &.full_width {
                width: 100%;
            }
        }

        &.application-handler {
            height: 30px;
            bottom: -30px;
        }
        }
    }

    .common-tips {
        color: #999999;
        font-size: 12px;
    }
    }
}
</style>
